export default {
  namespaced: true,
  users_rh: {
    title: "Usuarios Rh",
    soeid: "SOEID",
    name: "Nombre",
    first_name: "Ap. paterno",
    second_name: "Ap. materno",
    email: "Correo electrónico",
  }
};